import { useEffect, useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { setUser } from "../../redux/features/userSlice";
import { setJwtToken } from "../../redux/features/jwtTokenSlice";
import { setInit } from "../../redux/features/initSlice";
import CompleteUserProfileModal from "./CompleteUserProfileModal";
import { setAppState } from "../../redux/features/appStateSlice";

export default function UserStateComponent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const jwt_token = useSelector((state) => state.jwt_token);

  const init = useSelector((state) => state.init);

  const [lastPath, setLastPath] = useState("/");

  useEffect(() => {
    if (searchParams.get("jwt_token")) {
      localStorage.setItem("jwt_token", searchParams.get("jwt_token"));
      dispatch(setJwtToken(searchParams.get("jwt_token")));
      searchParams.delete("jwt_token");
      setSearchParams(searchParams);
      if (localStorage.getItem("last_path")) {
        navigate(localStorage.getItem("last_path"));
        localStorage.removeItem("last_path");
      } else {
        window.location.reload();
      }
    }
  }, [searchParams, setSearchParams, dispatch, lastPath, navigate]);

  useEffect(() => {
    if (location.pathname !== "/login" && location.pathname !== lastPath) {
      setLastPath(location.pathname);

      sessionStorage.setItem("last_path", location.pathname);
    }
  }, [location, setLastPath, lastPath]);

  const [getMe, { loading: loadingUser, data }] = useLazyQuery(
    gql`
      query {
        me {
          id
          email
          firstname
          lastname
          athlete_id
          club_id
          stats
          athlete_subscriptions_ids

          profile_media {
            url
          }
          group_memberships {
            group_id
            group {
              name
            }
          }
        }
      }
    `,
    {
      fetchPolicy: "network-only",
    }
  );

  useEffect(() => {
    if (!jwt_token || data) {
      dispatch(setInit(false));
    }
  }, [jwt_token, data, dispatch]);

  useEffect(() => {
    if (jwt_token) {
      getMe({
        context: {
          headers: { authorization: `Bearer ${jwt_token}` },
        },
      });
    }
  }, [jwt_token, getMe]);
  useEffect(() => {
    if (data?.me) {
      dispatch(
        setAppState({
          showCompleteUserProfileModal: data.me.athlete_id === null,
        })
      );
    }
  }, [data, dispatch]);

  useEffect(() => {
    if (loadingUser) {
      return;
    }

    dispatch(setUser(jwt_token ? data?.me ?? null : null));

    if (jwt_token && data && data.me) {
      if (location.pathname === "/login") {
        if (
          !lastPath.startsWith("/forgot-password") &&
          !lastPath.startsWith("/reset-password") &&
          !lastPath.startsWith("/onboarding")
        ) {
          navigate(lastPath);
        } else {
          navigate("/");
        }
      }
    }
    // const publicPages = [
    //   "/login",
    //   "/register",
    //   "/forgot-password",
    //   "/reset-password",
    //   "/onboarding",
    //   "/features",
    // ];
    // if (
    //   !init &&
    //   (!jwt_token || !data?.me) &&
    //   !publicPages.includes(location.pathname) &&
    //   !publicPages.filter((p) => location.pathname.startsWith(p)).length > 0 &&
    //   location.pathname !== "/"
    // ) {
    //   navigate("/login");
    // }
  }, [
    data,
    dispatch,
    loadingUser,
    navigate,
    lastPath,
    location,
    init,
    jwt_token,
  ]);

  return (
    <>
      <CompleteUserProfileModal />
    </>
  );
}
